import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Script from 'next/script';
import useIsEditing from 'lib/hooks/useIsEditing';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import { EditingFieldValues } from 'helpers/Editing/EditingFieldValues';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
export const LiveChat = ({ fields })=>{
    /**
   ** Refs & Hooks
   **/ const isEditing = useIsEditing();
    const { sitecoreContext } = useSitecoreContext();
    const { hideLiveChat } = sitecoreContext?.siteSettings ?? {};
    if (hideLiveChat?.value) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    if (!fields) {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    let scriptAttributes = {};
    if (fields?.additionalTagAttributes?.value) {
        scriptAttributes = Object.fromEntries(new URLSearchParams(fields?.additionalTagAttributes.value));
    }
    /**
   ** Rendering
   **/ if (isEditing) {
        return /*#__PURE__*/ _jsxs("div", {
            "data-component": "authorable/shared/content/livechat",
            suppressHydrationWarning: true,
            children: [
                /*#__PURE__*/ _jsx(EditingHelpText, {
                    priority: "normal",
                    children: "Microsoft Omnichannel Live Chat Widget - This component loads the live chat widget with custom styling for Irwin Mitchell. The chat will be visible on the published site."
                }),
                /*#__PURE__*/ _jsx(EditingFieldValues, {
                    hasRenderingParams: true,
                    fields: [
                        {
                            label: 'Live Chat Config',
                            field: fields?.liveChatConfig
                        },
                        {
                            label: 'Script Source URL',
                            field: fields?.scriptSourceUrl
                        },
                        {
                            label: 'Script Source URL ID',
                            field: fields?.scriptId
                        },
                        {
                            label: 'Additional Tag Attributes',
                            field: fields?.additionalTagAttributes
                        }
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            fields?.liveChatConfig?.value && /*#__PURE__*/ _jsx(Script, {
                id: "lcw-config",
                strategy: "lazyOnload",
                children: `${fields?.liveChatConfig?.value}`
            }),
            fields?.scriptSourceUrl?.value && /*#__PURE__*/ _jsx(Script, {
                id: fields?.scriptId?.value,
                src: fields?.scriptSourceUrl.value,
                strategy: "lazyOnload",
                ...scriptAttributes
            })
        ]
    });
};
export default LiveChat;
